import { useQuery } from "@apollo/client"
import { client } from "../../graphql/contentful/client"
import { gql } from "@apollo/client"

export const QUERY_PRODUCT_PAGE_COLLECTION = gql`
  query getAllProductPages {
    productPageCollection {
      items {
        title
        promoTitleOne
        promoTitleGradient
        promoSubtitle
        internetCoverageTitle
        internetCoverageText
        uspOneTitle
        uspOneText
        uspTwoTitle
        uspTwoText
        uspThreeTitle
        uspThreeText
        uspFourTitle
        uspFourText
        applicationsTitle
        applicationsText
        quote
      }
    }
  }
`

export const useProductPageCollection = () => {
  const { data, error, loading, refetch } = useQuery(QUERY_PRODUCT_PAGE_COLLECTION, {
    client: client,
  })
  return {
    productPages: data?.productPageCollection,
    error: error,
    loading: loading,
    refetch,
  }
}
